export default __webpack_public_path__ + "static/media/Pistol_8.d8b83bc6.png";